import React, { useState, useMemo, useEffect } from 'react';
import MemberLevelStyled from './MemberLevelStyled';
import { Button, useTheme } from '@material-ui/core';
import CouponModal from '../../coupon_modal/index';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import { Switch } from 'antd';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import ChooseCoupon from './choose_coupon/index';
import { useIntl } from 'umi';

export default (props) => {
  const { control } = useForm();
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    memberLevelData: memberLevelList,
    setMemberLevel,
    opt,
    id,
    ids,
    // allLevelMember=[],
    setIsSave,
  } = props;
  const memberLevelListJSON = JSON.stringify(memberLevelList);
  const intl = useIntl();
  const { formatMessage } = intl;
  //会员等级
  // eslint-disable-next-line no-unused-vars
  const memberLevel = useSelector((state) => state.sceneMarketing.memberLevel);

  const [dialogStatus, setDialogStatus] = useState(false);
  const [couponOpen, setCouponOpen] = useState(false);
  // 展示优惠券列表的弹窗
  const allCoupons = useSelector((state) => state.sceneMarketing?.allCoupons);

  const couponIds = useSelector((state) => state.sceneMarketing?.couponIds);

  // 每个数组里的coupon
  const [couponId, setCouponId] = useState();
  const [coupons, setCoupons] = useState([]);
  const [type, setType] = useState();
  const [modify, setModify] = useState({});
  // 获取会员等级列表
  useEffect(() => {
    dispatch({ type: 'sceneMarketing/getMemberLevel' });
  }, [dispatch]);

  const newMemberLvList = useMemo(() => {
    if (memberLevelList?.length > 0) {
      let newArr = [];
      memberLevelList.forEach((memberLv) => {
        let newMemberLv = { ...memberLv };
        let num = 0;
        if (memberLv?.coupons !== null && Array.isArray(memberLv?.coupons)) {
          for (let i = 0; i < memberLv?.coupons?.length; i++) {
            num =
              Number(num || 0) + Number(memberLv?.coupons[i]?.couponCode || 0);
          }
          newMemberLv['couponNum'] = num;
          memberLv.coupons &&
            memberLv.coupons.forEach((i) => {
              if (!i.id) {
                newMemberLv[i]['id'] = i.couponId;
                // i['id'] = i.couponId;
              }
            });
        } else {
          memberLv['couponNum'] = 0;
        }
        newArr.push(newMemberLv);
      });
      return newArr;
    }
  }, [memberLevelListJSON]);

  const handleChangeStatus = (e, index) => {
    newMemberLvList[index].status = e;
    dispatch({
      type: 'sceneMarketing/saveDiffMember',
      payload: {
        value: newMemberLvList,
      },
    });
    setMemberLevel(newMemberLvList);
  };

  // 得到张数
  useMemo(() => {
    if (couponIds > 0) {
      let num = 0;
      newMemberLvList &&
        newMemberLvList.forEach((item) => {
          if (item.level === couponIds) {
            for (let i = 0; i < allCoupons[couponIds].length; i++) {
              num =
                Number(num) + Number(allCoupons[couponIds][i]?.couponCode || 0);
            }
            item['coupons'] = allCoupons[couponIds];
            item['couponNum'] = num;
          }
          if (item.code === couponIds) {
            for (let i = 0; i < allCoupons[couponIds].length; i++) {
              num =
                Number(num) + Number(allCoupons[couponIds][i]?.couponCode || 0);
            }
            item['coupons'] = allCoupons[couponIds];
            item['couponNum'] = num;
          }
        });
      setMemberLevel(newMemberLvList);
      dispatch({
        type: 'sceneMarketing/saveDiffMember',
        payload: {
          value: newMemberLvList,
        },
      });
    }
  }, [couponIds, couponId, modify, allCoupons]);

  const handleSetting = (item) => {
    // 点击打开modal
    // 存到model里
    setCoupons(item?.coupons || []);
    const arr = [];

    if (item?.coupons?.length > 0 && Array.isArray(item?.coupons)) {
      setDialogStatus(true);
    } else {
      setCouponOpen(true);
      // seIsHasCoupons(false);
    }
    dispatch({
      type: 'sceneMarketing/saveCouponsList',
      payload: {
        value: item?.coupons || arr,
      },
    });
    const code = item.level ? item.level : item.code || 0;
    setCouponId(code);
    dispatch({
      type: 'sceneMarketing/saveItemCoupons',
      payload: {
        value: {
          id: code,
          coupons: item?.coupons || arr,
        },
      },
    });
    dispatch({
      type: 'sceneMarketing/saveCouponsId',
      payload: {
        value: code,
      },
    });
    setType(item.level === null ? 'allLevel' : 'memberLevel');
  };

  const levelStatus = (level) => {
    const levelNum = Number(level) - 1;
    return memberLevel[levelNum]?.name;
  };

  const showLevelData = (data) => {
    return data?.map((item, index) => (
      <div className="level-content">
        <div
          className={
            item?.name === '-' || item.level === null
              ? 'all-level'
              : 'forth-level'
          }
        >
          {item.name ? item.name : item.level ? levelStatus(item.level) : '-'}
        </div>
        <div>
          <SvgIconML
            name={'coupon'}
            className={item?.couponNum > 0 ? 'coupon' : 'noCoupon'}
          ></SvgIconML>
          <span>
            {item?.couponNum || 0}
            {/* 张 */}
            {formatMessage({ id: 'comm.chart.lbl.10' })}
          </span>
          {/* 点击设置打开弹窗 */}
          <Button
            onClick={() => handleSetting(item)}
            disabled={opt === 'detail'}
            className={
              item?.couponNum > 0
                ? 'coupon-settings coupons'
                : 'coupon-settings noCoupons'
            }
          >
            {item?.couponNum > 0
              ? formatMessage({ id: 'marketing.scene.holiday.c02.txt02' })
              : formatMessage({ id: 'marketing.scene.holiday.c02.txt01' })}
          </Button>
        </div>
        <Controller
          render={(pr) => (
            <Switch
              checkedChildren={formatMessage({
                id: 'marketing.scene.holiday.c02.txt03',
              })}
              unCheckedChildren={formatMessage({
                id: 'marketing.scene.holiday.c02.txt04',
              })}
              checked={Boolean(item.status)}
              // defaultChecked={Boolean(item.status)}
              onClick={(e) => {
                handleChangeStatus(e, index);
                return pr.onChange(e);
              }}
              disabled={opt === 'detail'}
            />
          )}
          control={control}
          name="point"
        ></Controller>
      </div>
    ));
  };

  return (
    <MemberLevelStyled theme={theme}>
      {newMemberLvList?.length > 0 && showLevelData(newMemberLvList)}
      {/* {newMemberLvList?.length<4&&newAllMemberLevel?.length > 0&& showLevelData(newAllMemberLevel)} */}
      <CouponModal
        couponType={type}
        dialogStatus={dialogStatus}
        setDialogStatus={setDialogStatus}
        coupons={coupons}
        setCoupons={setCoupons}
        // 每条数据的唯一标志
        couponId={couponIds}
        ids={ids}
        editId={id}
        // modify, setModi//fy
        setModify={setModify}
        setIsSave={setIsSave}
      ></CouponModal>
      {/* 新建时弹出框 */}
      <ChooseCoupon
        dialogStatus={couponOpen}
        setDialogStatus={setCouponOpen}
        couponId={couponIds}
        setCoupons={setCoupons}
        setModify={setModify}
      ></ChooseCoupon>
    </MemberLevelStyled>
  );
};
